import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { headerLanguages } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { sendData } from "../../../services/sendData";
import { emptys, langsCodes } from "../../../data/main";
import { langWords } from "../../../data/types/langWords";
import { useTranslation } from "react-i18next";
import en from "../../../locales/en.json";
import es from "../../../locales/es.json";
import { openLangInfo } from "../../MainFrame/functions/language/openLangInfo";

export default function LanguageBox() {
  const { t, i18n } = useTranslation();
  const { type, searchValues, section } = useStructureContext();
  const {
    setMsg,
    windowValues,
    setModalData,
    setWindowValues,
    closeMsg,
    logoutAction,
  } = useMainContext();
  const langList: stdObject = { en, es };

  const openLanguage = async (v: stdObject, index: number) => {
    setMsg("loading");
    const responseLang: stdObject = await sendData({
      endPoint: "callLang",
      payload: { codes: [v.CODE, v.INDEX] },
      logoutAction,
    });
    console.log("responseLang", responseLang);
    if (responseLang.success && responseLang.status) {
      openLangInfo(
        {
          code: v.CODE,
          prefix: v.INDEX,
          name: v.CODLAN,
          index,
          langs: Object.entries(langsCodes),
          data: responseLang.data,
        },
        false,
        {
          windowValues,
          setMsg,
          setModalData,
          setWindowValues,
          closeMsg,
          logoutAction,
        },
      );
    } else {
      setMsg("error");
    }
  };

  const mainValue:
    | "general"
    | "purchasesMenu"
    | "purchases"
    | "salesMenu"
    | "sales"
    | "servicesMenu"
    | "lists"
    | "warehouse"
    | "admin"
    | "settings"
    | "document" = emptys.includes(searchValues[section.id]?.GRULAN?.value)
    ? "general"
    : searchValues[section.id]?.GRULAN?.value;

  return "GRULAN" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerLanguages}
        data={langWords[mainValue].list.map((e: string) => {
          return {
            CODE: e,
            INDEX: langWords[mainValue].code,
            CODLAN:
              langList[i18n.language].translation[langWords[mainValue].code][e],
            EN: t(`${langWords[mainValue].code}.${e}`, { lng: "en" }),
            ES: t(`${langWords[mainValue].code}.${e}`, { lng: "es" }),
          };
        })}
        onDoubleClick={openLanguage}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
